import { useEffect, useState } from "react";
import axios from "axios";
import CustomBarChart from "../Charts/CustomBarChart";
import CommonCard from "../ui/CommonCard/CommonCard";
import classes from "./LabDashboard.module.css";
import { useAuth } from "../../context/AuthContext";
import { env } from "../../constants/env";
import { db } from "../../utils/offlineDB";

const colorPalette = ["#C607CA", "#1302FB", "#1CDF03", "#FE9900", "#E60101"];

const AssessorDashboard = () => {
  const { user, token } = useAuth();
  const labId = user?.labId;

  const [labs, setLabs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  console.log("Lab ID in Dashboard:", labs);

  useEffect(() => {
  const fetchLabs = async () => {
    setLoading(true);
    try {
      // 1️⃣ Try local DB
      const localLabs = await db.offlineLabs.toArray();
      if (localLabs.length > 0) setLabs(localLabs);

      // 2️⃣ If online, fetch server labs and update DB
      if (navigator.onLine) {
        const res = await axios.get(`${env.kataApiUrl}/api/labs`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const serverLabs = res.data;
        setLabs(serverLabs); // update state

        const savePromises = serverLabs.map((lab) =>
          db.offlineLabs.put({
            ...lab,
            id: lab._id || lab.id,
            offline: false,
            lastSynced: new Date().toISOString(),
            timestamp: Date.now(),
          })
        );
        await Promise.all(savePromises);
      }

    } catch (err) {
      console.error("Failed to fetch labs:", err);
      setError("Failed to fetch labs");
    } finally {
      setLoading(false);
    }
  };

  fetchLabs();
}, [token]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;
  if (!labs || labs.length === 0) return <p>Labs not found</p>;

  // Aggregate staff distribution
  const staffDistribution = labs.reduce(
    (acc, lab) => {
      acc.Degree += lab.degreeHolders || 0;
      acc.Diploma += lab.diplomaHolders || 0;
      acc.Certificate += lab.certificateHolders || 0;
      acc.Clerks += lab.dataClerks || 0;
      acc.Phlebotomists += lab.phlebotomists || 0;
      acc.Cleaners += lab.cleaners || 0;
      acc.Drivers += lab.drivers || 0;
      acc.Others += lab.others || 0;
      return acc;
    },
    { Degree: 0, Diploma: 0, Certificate: 0, Clerks: 0, Phlebotomists: 0, Cleaners: 0, Drivers: 0, Others: 0 }
  );

  const chartData = Object.entries(staffDistribution).map(([name, number]) => ({ name, number }));

  return (
    <div className={classes.wrapper}>
      <h2>Dashboard</h2>

      {/* Bar Chart */}
      <CommonCard>
        <div className={classes.cardHeader}>
          <h5>Laboratories staff distribution</h5>
        </div>
        <CustomBarChart data={chartData} colors={colorPalette} />
      </CommonCard>
    </div>
  );
};

export default AssessorDashboard;